import React, { Fragment } from 'react'
import AEAAdminsList from './AEAAdminsList'

const AEAAdmins = () => {
    return (
        <Fragment>
            <div className="m-sm-30">
                <h3 className="m-0 mb-6">Liste des administrateurs</h3>
                <AEAAdminsList />
            </div>
        </Fragment>
    )
}

export default AEAAdmins
